$shm_hitalama_components_settings $mol_view
	definition $shm_hitalama_map_widget_entity_custom
	saving false
	save_error \
	removed? null
	sub /
		<= Name $mol_labeler
			title \Название
			Content <= Name_input $mol_string
				enabled <= editable false
				value? <=> name? \
		<= Description $mol_labeler
			title \Описание
			Content <= Description_input $mol_textarea
				enabled <= editable
				value? <=> description? \
		<= Widget_type $mol_check_box
			title \Использовать как тип виджета (отображать в контекстном меню)
			enabled <= editable
			checked? <=> widget_type? false
		<= Fqn $mol_labeler
			title \FQN
			Content <= Fqn_input $mol_string
				enabled false
				value <= fqn \
		<= Remove $shm_confirm_delete
			title \Удалить приложение и модули
			question <= remove_question \
			trigger_enabled <= remove_enabled false
			confirmed? <=> remove? null
		<= Repository $mol_labeler
			title \GitHub-репозиторий
			Content <= Repository_input $mol_string
				enabled <= repository_editable false
				hint \https://github.com/владелец/репозиторий
				value? <=> repository? \
		<= Github_hint $mol_text
			text \Адрес формируется из владельца GitHub в настройках и FQN приложения без символа $. Можно указать другой репозиторий вручную. Внутренние модули используют общий репозиторий, коммиты и историю версий приложения. Актуальный код хранится здесь; GitHub сохраняет историю файлов.
		<= Status $mol_status
			status <= status \
			attr *
				^
				data-sync-state <= sync_state \
		<= Actions $mol_view
			sub /
				<= Refresh $mol_button_minor
					title \Обновить проверку
					click? <=> refresh? null
				<= Commit $mol_button_major
					title \Сделать коммит
					enabled <= commit_enabled false
					click? <=> commit? null
